class BeforeAfterSlider {
  constructor(section) {
    this.section = section;
    this.media = section.querySelector('[data-ba-media]');
    this.afterImage = section.querySelector('[data-ba-after]');
    this.divider = section.querySelector('[data-ba-divider]');
    this.handle = section.querySelector('[data-ba-handle]');

    if (!this.media || !this.afterImage || !this.divider || !this.handle) return;

    this.isDragging = false;
    this.isPending = false;
    this.startX = 0;
    this.startY = 0;
    this.rafId = null;
    this.pendingEvent = null;
    this.position = parseFloat(section.dataset.initialPosition) || 50;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.setPosition(this.position);
    this.bindEvents();
  }

  bindEvents() {
    this.handle.addEventListener('pointerdown', this.onPointerDown);
    this.media.addEventListener('pointerdown', this.onPointerDown);
    this.handle.addEventListener('keydown', this.onKeyDown);
    this.handle.setAttribute('tabindex', '0');
    this.handle.setAttribute('role', 'slider');
    this.handle.setAttribute('aria-valuemin', '0');
    this.handle.setAttribute('aria-valuemax', '100');
  }

  onPointerDown(event) {
    this.startX = event.clientX;
    this.startY = event.clientY;

    // On touch, wait to see if the gesture is horizontal before
    // committing to a drag, so vertical page scroll isn't blocked.
    if (event.pointerType === 'touch' && event.target !== this.handle) {
      this.isPending = true;
    } else {
      this.isDragging = true;
      this.section.setAttribute('data-dragging', 'true');
      this.updateFromEvent(event);
    }

    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
  }

  onPointerMove(event) {
    if (this.isPending) {
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;

      if (Math.abs(dx) > Math.abs(dy)) {
        this.isPending = false;
        this.isDragging = true;
        this.section.setAttribute('data-dragging', 'true');
      } else {
        // Vertical gesture: let the page scroll, cancel this drag attempt.
        this.isPending = false;
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        return;
      }
    }

    if (!this.isDragging) return;

    this.pendingEvent = event;
    if (this.rafId) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.updateFromEvent(this.pendingEvent);
    });
  }

  onPointerUp() {
    this.isDragging = false;
    this.isPending = false;
    this.section.setAttribute('data-dragging', 'false');
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
  }

  onKeyDown(event) {
    let delta = 0;
    if (event.key === 'ArrowLeft') delta = -5;
    if (event.key === 'ArrowRight') delta = 5;
    if (delta === 0) return;
    event.preventDefault();
    this.setPosition(this.position + delta);
  }

  updateFromEvent(event) {
    const rect = this.media.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const percent = (x / rect.width) * 100;
    this.setPosition(percent);
  }

  setPosition(percent) {
    this.position = Math.min(100, Math.max(0, percent));
    this.afterImage.style.clipPath = `inset(0 0 0 ${this.position}%)`;
    this.divider.style.left = `${this.position}%`;
    this.handle.setAttribute('aria-valuenow', Math.round(this.position));
  }
}

function initBeforeAfterSliders() {
  document.querySelectorAll('[data-ba-slider]').forEach((section) => {
    if (section.__baSliderInitialized) return;
    section.__baSliderInitialized = true;
    new BeforeAfterSlider(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBeforeAfterSliders);
} else {
  initBeforeAfterSliders();
}

document.addEventListener('shopify:section:load', initBeforeAfterSliders);
